import { DialogActions, DialogActionsProps, makeStyles } from '@material-ui/core';
import React from 'react';

export type ModalWindowActionsProps = DialogActionsProps & {
}

export function ModalWindowActions (props: ModalWindowActionsProps) {
    const cls = useStyles();

    return (
        <DialogActions className={cls.root} {...props} />
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .1)'
    }
}));